import React, { createContext, useContext, useRef, useCallback } from 'react';

const CacheContext = createContext();

const CACHE_TTL = 5 * 60 * 1000;

export function CacheProvider({ children }) {
    const cacheRef = useRef({});

    const get = useCallback((key) => {
        const entry = cacheRef.current[key];
        if (!entry) return null;
        if (Date.now() - entry.timestamp > CACHE_TTL) {
            delete cacheRef.current[key];
            return null;
        }
        return entry.data;
    }, []);

    const set = useCallback((key, data) => {
        cacheRef.current[key] = { data, timestamp: Date.now() };
    }, []);

    const invalidate = useCallback((key) => {
        delete cacheRef.current[key];
    }, []);

    const invalidateAll = useCallback(() => {
        cacheRef.current = {};
    }, []);

    return (
        <CacheContext.Provider value={{ get, set, invalidate, invalidateAll }}>
            {children}
        </CacheContext.Provider>
    );
}

export function useCache() {
    const context = useContext(CacheContext);
    if (!context) {
        throw new Error('useCache must be used within a CacheProvider');
    }
    return context;
}
